import { Component, OnInit } from '@angular/core';
import { VersionService } from "@app/services/version/version.service";
import { APP_VERSION } from "@app/version.constant";

interface AppVersionInfo {
  frontend: {
    name: string;
    version: string;
  };
  backend: {
    name: string;
    version: string;
  };
  buildDate?: string;
}

@Component({ standalone: false, selector: 'app-version-info',
  templateUrl: './version-info.component.html',
})
export class VersionInfoComponent implements OnInit {
  versionInfo: AppVersionInfo = {
    frontend: {
      name: 'SITE Front',
      version: APP_VERSION.frontend
    },
    backend: {
      name: 'SITE API',
      version: '-',
    },
    buildDate: APP_VERSION.buildDate,
  };

  constructor(
    private readonly versionService: VersionService,
  ) {
  }

  ngOnInit() {
    this.versionService.getVersion().then((version: string) => {
      this.versionInfo.backend.version = version;
    });
  }
}
